import { Dropdown } from "primereact/dropdown";

export const tbalePaginatorSetting = {
  layout:
    "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  RowsPerPageDropdown: (options) => {
    const dropdownOptions = [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      // { label: "All", value: options.totalRecords },
    ];

    return (
      <Dropdown
        className="flex align-items-center"
        value={options.value}
        options={dropdownOptions}
        onChange={options.onChange}
      />
    );
  },
};
